module.exports = __webpack_public_path__ + "toBride1-jp-r-b.8603fa24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-jp-r-b.jpg
// module id = Lj7d
// module chunks = 0